//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState } from "vuex";

import QfMScriptEditor from "@/components/UserInterfaces/properties/script-editor/qf-m-script-editor.vue";
import QfLayers from "./qf-layers.vue";

import InterfaceLoad from "../mixins/interface-load";
import QfPageProperties from "./qf-page-properties.vue";
import QfComponentProperties from "./qf-component-properties.vue";
import QfModel from "./qf-model.vue";

let currentKeyEdit = null;

export default {
    name: "QfUiRightContainer",
    components: {
        QfModel, QfComponentProperties, QfPageProperties, QfLayers, QfMScriptEditor
    },
    mixins: [InterfaceLoad],
    data() {
        return {
            showModal: false,
            scriptContent: null,
            currentEdit: null,
            section: "config",
            lastRead: 0,
            loadData: 0
        };
    },
    computed: {
        ...mapState("components", ["readOnly", "qfDebug", "activeComponent", "properties", "issues", "componentsPropertiesCategories"]),
        issuesReverse() {
            return this.issues.slice().reverse();
        },
        errorClasses() {
            let classes = [];
            if (this.issues.length !== this.lastRead) {
                classes = ["animate-blink", "text-red"];
            }

            return classes;
        },
        readonlyPermission() {
            return this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly;
        }
    },
    created() {
        this.$root.$on("nodeClicked", value => {
            this.loadData = value;
            this.resetRightPannelTabs();
        });
    },
    activated() {
        this.resetRightPannelTabs();
    },
    methods: {
        ...mapMutations("components", ["setActiveComponent", "setSelectPath"]),
        editScript(data) {
            const { event, key } = data;
            const properties = this.properties[key];
            this.scriptContent = properties.__events[event] || properties.__customEvents[event] || "";

            currentKeyEdit = key;
            this.currentEdit = event;
            this.showModal = true;
        },
        nodeClick(node) {
            const { key, traversePath } = node;
            if (key === "body") {
                this.setActiveComponent(null);
            } else if (this.activeComponent !== key) {
                if (traversePath.length === 1) {
                    this.setSelectPath(traversePath);
                } else {
                    this.setSelectPath(traversePath);
                }
            }
        },
        onUpdate(value) {
            const { __events } = this.properties[currentKeyEdit];
            if (__events[this.currentEdit]) {
                __events[this.currentEdit] = value;
            } else {
                const { __customEvents } = this.properties[currentKeyEdit];
                __customEvents[this.currentEdit] = value;
            }
        },
        errorsClick() {
            this.section = "errors";
            this.lastRead = this.issues.length;
        },
        resetRightPannelTabs() {
            this.section = "config";
        },
        componentPropertiesActions(payload) {
            this.$emit("action", payload);
        },
        onLiveTest(state) {
            this.$emit("action", { action: "live-test", state });
        },
        btnClasses: active => (active ? "active" : "section")
    }
};
